module.exports = __webpack_public_path__ + "static/media/galomonitor-logo.92a0b1be.svg";